import React, { useState } from "react";
import "./CreateOutputFormat.css";
import { Input, Drawer } from "antd";
import UploadOutComputer from "./UploadOutComputer/UploadOutComputer";
import OwnOutData from "./OwnOutData/OwnOutData";
import {
  RiArrowLeftLine,
  RiFileUploadFill,
  RiEditBoxFill,
} from "react-icons/ri";
const CreateOutputFormat = ({
  isCreateOutputFormat,
  handleCreateOutputFormat,
  workspaceFolderFlag,
  workspace_id,
  folder_id,
  workspaceId,
  workspaceByIdStatus,
  folderByIdStatus,
}) => {
  const SideClose = "/assets/ModalClose.svg";
  const [isUploadOutComputer, setIsUploadOutComputer] = useState(false);
  const [isOwnOutData, setIsOwnOutData] = useState(false);
  const [name, setName] = useState("");
  const [context, setContext] = useState("");

  const [isDragging, setIsDragging] = useState(false);
  const [DragDropFile, setDragDropFile] = useState("");

  const handleSupportingDocumentButtonClick = () => {
    setIsUploadOutComputer(false);
    setIsOwnOutData(false);
  };
  const handleUploadOutComputer = () => {
    setIsUploadOutComputer(true);
    setIsOwnOutData(false);
    setDragDropFile("");
  };
  const handleOwnOutData = () => {
    setIsUploadOutComputer(false);
    setIsOwnOutData(true);
  };
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleContextChange = (e) => {
    setContext(e.target.value);
  };

  //drag and drop
  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    setIsUploadOutComputer(true);
    // setIsUploadOutComputer(true);
    // setRunStatusMainData("");
    const files = e.dataTransfer.files;

    setDragDropFile(files);
  };
  return (
    <>
      <Drawer
        placement="right"
        closable={false}
        onClose={handleCreateOutputFormat}
        open={isCreateOutputFormat}
        key="right"
        width={"45%"}
      >
        <img
          className="supporting-document-out-sideClose"
          src={SideClose}
          alt=""
          onClick={handleCreateOutputFormat}
        />

        <div className="supporting-document-out-modal-div">
          <h3>Create Output Format</h3>
          {isUploadOutComputer || isOwnOutData ? (
            <p
              className="supporting-document-out-back"
              onClick={handleSupportingDocumentButtonClick}
            >
              <RiArrowLeftLine className="supporting-document-out-back-svg" />{" "}
              Back
            </p>
          ) : null}
        </div>
        <div className="supporting-document-out-input">
          {isUploadOutComputer || isOwnOutData ? null : (
            <>
              <div className="supporting-document-out-2">
                <label>Output format name</label>
                <Input
                  placeholder="Basic usage"
                  name="name"
                  value={name}
                  onChange={handleNameChange}
                />
              </div>
              {/* <div className="supporting-document-out-2">
                <label>
                  Context to frame reference data (edit if required)
                </label>
                <Input
                  placeholder="Basic usage"
                  name="context"
                  value={"This is the " + name + ":"}
                  onChange={handleContextChange}
                />
              </div> */}
            </>
          )}
          {isUploadOutComputer ? (
            <UploadOutComputer
              workspaceFolderFlag={workspaceFolderFlag}
              workspace_id={workspace_id}
              isUploadOutComputer={isUploadOutComputer}
              folder_id={folder_id}
              name={name}
              context={context}
              handleCreateOutputFormat={handleCreateOutputFormat}
              handleSupportingDocumentButtonClick={
                handleSupportingDocumentButtonClick
              }
              DragDropFile={DragDropFile}
              setDragDropFile={setDragDropFile}
              workspace_sd={workspaceId}
              workspaceByIdStatus={workspaceByIdStatus}
            />
          ) : null}
          {isOwnOutData ? (
            <OwnOutData
              workspaceFolderFlag={workspaceFolderFlag}
              workspace_id={workspace_id}
              folder_id={folder_id}
              name={name}
              context={context}
              handleCreateOutputFormat={handleCreateOutputFormat}
              handleSupportingDocumentButtonClick={
                handleSupportingDocumentButtonClick
              }
              workspace_sd={workspaceId}
              workspaceByIdStatus={workspaceByIdStatus}
            />
          ) : null}
          {isUploadOutComputer || isOwnOutData ? null : (
            <div className="supporting-document-out-2">
              <label>Choose from</label>
              <div
                className={`drag-drop-field supporting-document-out-2 ${
                  isDragging ? "dragging" : ""
                }`}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                <div className="supporting-document-out-upload-img-height-320">
                  <div className="supporting-document-out-upload-main-div">
                    <div className="supporting-document-out-upload-span">
                      <div className="supporting-document-out-upload-sub-div">
                        <div className="supporting-document-out-upload-middle-div-first-p">
                          {
                            "Drag & Drop Your file or click to upload (PDF, MP3, MP4, DOCX or txt files)"
                          }
                        </div>
                        <div className="supporting-document-out-upload-middle-div-second-p">
                          Or
                        </div>
                        <div
                          className="supporting-document-out-upload-middle-div-tree-p"
                          onClick={handleUploadOutComputer}
                        >
                          <div className="supporting-document-out-image-button">
                            <RiFileUploadFill className="supporting-document-out-sideIcon-size supporting-document-out-color-text" />{" "}
                            Upload from Computer
                          </div>
                        </div>
                        <div
                          className="supporting-document-out-upload-middle-div-tree-p"
                          onClick={handleOwnOutData}
                        >
                          <div className="supporting-document-out-image-button">
                            <RiEditBoxFill className="supporting-document-out-sideIcon-size supporting-document-out-color-text" />{" "}
                            Enter Your Own Data
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Drawer>
    </>
  );
};
export default CreateOutputFormat;
